import { ApiError } from "./apiError";
import { navigateTo } from "./navigation";

export async function retryWithAuth<T>(
  fn: () => Promise<T>,
  retries: number = 1,
  options?: {
    redirectOnNotFound?: boolean;
    redirectOnForbidden?: boolean;
  }
): Promise<T> {
  let attempts = 0;
  const redirectOnNotFound = options?.redirectOnNotFound ?? true;
  const redirectOnForbidden = options?.redirectOnForbidden ?? true;

  while (attempts <= retries) {
    try {
      return await fn();
    }
    catch (error) {
      if (!(error instanceof ApiError)) {
        throw error;
      }

      if (error.isBadRequest()) {
        console.warn("400 → bad request");
        throw error; // component handelt dit af
      }

      // 🔁 401 → refresh token
      if (error.isUnauthorized()) {
        attempts++;

        if (attempts > retries) {
          console.warn("401 → redirect to login");
          navigateTo("/verlopen");
          throw error;
        }

        continue;
      }

      // 403
      if (error.isForbidden()) {
        if (redirectOnForbidden) {
          navigateTo("/niet-toegestaan");
        }
        throw error;
      }

      // 404
      if (error.isNotFound()) {
        if (redirectOnNotFound) {
          navigateTo("/niet-gevonden");
        }
        throw error;
      }

      // 422 → validation → laat component beslissen
      if (error.isValidation()) {
        throw error;
      }

      // 500
      if (error.isServerError()) {
        navigateTo("/server-fout");
        throw error;
      }

      throw error;
    }
  }

  throw new Error("Retry failed unexpectedly");
}
